import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M9.5 11.5H5.5V7.5H9.5V11.5ZM18.5 11.5H14.5V7.5H18.5V11.5ZM8.35 17L6.35 13H11V6H4V13.2L5.9 17H8.35ZM17.35 17L15.35 13H20V6H13V13.2L14.9 17H17.35Z" fill="black"/>
</svg>
;
